import React, { useEffect, useRef, useState } from 'react';
import { Alert, Input, Modal, Space, Typography } from 'antd';
import { OrderDto } from '@shared/api/hooks/useOrders';

interface Props {
  open: boolean;
  orders: OrderDto[];
  onClose: () => void;
  onMatch: (order: OrderDto) => void;
}

/**
 * Pickup QR scanner — input testo per ora (no webcam dep aggiuntiva).
 * Su match (anche prefisso 4+ chars) propone ordine all'operatore.
 */
export function ScanQrModal({
  open,
  orders,
  onClose,
  onMatch,
}: Props): React.ReactElement {
  const [code, setCode] = useState('');
  const inputRef = useRef<{ focus: () => void }>(null);

  useEffect(() => {
    if (open) {
      setCode('');
      setTimeout(() => inputRef.current?.focus(), 100);
    }
  }, [open]);

  const normalized = code.trim().toUpperCase();
  const matches = normalized.length >= 4
    ? orders.filter((o) =>
        o.pickupQrCode.toUpperCase().includes(normalized),
      )
    : [];
  const exact = matches.find(
    (o) => o.pickupQrCode.toUpperCase() === normalized,
  );

  useEffect(() => {
    if (exact) {
      onMatch(exact);
    }
  }, [exact, onMatch]);

  return (
    <Modal
      open={open}
      title="Scan QR ritiro"
      onCancel={onClose}
      footer={null}
      destroyOnClose
    >
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        <Typography.Text type="secondary">
          Inquadra o digita il codice mostrato dal cliente.
        </Typography.Text>
        <Input
          ref={inputRef as unknown as React.Ref<unknown> as React.Ref<never>}
          size="large"
          placeholder="ORD-LAN-2026-XXXXXX"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          allowClear
          autoFocus
          style={{ fontFamily: 'monospace', letterSpacing: 1 }}
        />
        {normalized.length >= 4 && matches.length === 0 && (
          <Alert
            type="warning"
            message="Nessun ordine corrispondente in coda pickup."
            showIcon
          />
        )}
        {!exact && matches.length > 0 && (
          <Space direction="vertical" size={2} style={{ width: '100%' }}>
            <Typography.Text strong>Possibili match:</Typography.Text>
            {matches.slice(0, 5).map((o) => (
              <Typography.Text
                key={o.id}
                code
                style={{ cursor: 'pointer' }}
                onClick={() => onMatch(o)}
              >
                {o.pickupQrCode} · {o.finalAmount.toFixed(2)} {o.currency}
              </Typography.Text>
            ))}
          </Space>
        )}
      </Space>
    </Modal>
  );
}
